import { isMyMessage, type Msg } from '@halo/chat-sdk';
import { useMemo } from 'react';
import { useStaticAppStore } from './useStaticAppStore';

export function useIsMyMsg(message: Msg | undefined) {
  const { user } = useStaticAppStore();

  return useMemo(() => isMyMessage(message, user?.user_id), [message, user?.user_id]);
}
